import React, { useCallback } from 'react';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useRemoveBanner = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const removeBanner = useCallback(
        async (bannerId: number) => {
            try {
                await services.api.call({
                    method: 'delete',
                    url: `/api/banners/${bannerId}`,
                });
                services.events.publish(events.banner_list_updated);
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.banner_list_updated]
    );

    return removeBanner;
};
